import { Truck, PackageX, Clock, ShieldAlert } from "lucide-react";
import { LEGAL } from "@/lib/brand";

export default function Shipping() {
  return (
    <div>
      <section className="border-b border-ape-border bg-ape-surface">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-16">
          <span className="font-mono2 text-xs tracking-[0.3em] text-ape-red">POLICIES</span>
          <h1 className="font-display text-5xl sm:text-7xl tracking-tight mt-2">SHIPPING &amp; REFUNDS</h1>
          <p className="text-ape-muted mt-3 max-w-xl">Secure, discreet, and reliable. Here's everything you need to know about how we ship and our refund policy.</p>
        </div>
      </section>

      <section className="max-w-4xl mx-auto px-4 sm:px-6 py-16 space-y-8">
        <div className="border border-ape-border bg-ape-surface p-8">
          <div className="flex items-center gap-3 mb-4"><Truck className="text-ape-red" size={26} /><h2 className="font-display text-3xl tracking-wide">SHIPPING POLICY</h2></div>
          <p className="text-white/90 leading-relaxed">
            Please allow <span className="text-ape-red font-semibold">5–10 business days</span> for your order to be processed, packaged, and delivered. Shipping times may vary depending on order volume, carrier delays, holidays, and other unforeseen circumstances. Tracking information will be provided once your order has been shipped.
          </p>
          <div className="grid sm:grid-cols-3 gap-4 mt-6">
            {[
              { icon: Clock, t: "5–10 Business Days", s: "Standard processing & delivery" },
              { icon: Truck, t: "Discreet Packaging", s: "Secure & confidential" },
              { icon: ShieldAlert, t: "Tracking Provided", s: "Sent once shipped" },
            ].map((c, i) => (
              <div key={i} className="border border-ape-border bg-ape-bg p-5">
                <c.icon className="text-ape-red" size={24} />
                <div className="font-head uppercase tracking-wide text-sm mt-3">{c.t}</div>
                <div className="text-ape-muted text-xs mt-1">{c.s}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="border border-ape-border bg-ape-surface p-8">
          <div className="flex items-center gap-3 mb-4"><PackageX className="text-ape-red" size={26} /><h2 className="font-display text-3xl tracking-wide">REFUND POLICY</h2></div>
          <p className="text-white/90 leading-relaxed">
            Due to the nature of our products being sold as research compounds, <span className="text-ape-red font-semibold">all sales are considered final</span>. We do not accept returns, exchanges, or refunds once an order has been placed. By completing your purchase, you acknowledge and agree to these terms.
          </p>
        </div>

        <div className="border border-ape-red bg-ape-red/10 p-5 font-mono2 text-xs tracking-widest text-ape-red text-center">
          {LEGAL}
        </div>
      </section>
    </div>
  );
}
